import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  BatchShort,
  BatchStatus,
  BatchStatusEnum,
  DuplicateType,
} from '../../models';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Input() public data: BatchShort[];
  @Input() public selected: number[];
  @Output() public duplicateChange: EventEmitter<DuplicateType> =
    new EventEmitter<DuplicateType>();
  @Output() public removeChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() public searchChange: EventEmitter<string | null> = new EventEmitter<
    string | null
  >();

  public readonly faTrashAlt = faTrashAlt;
  public readonly BatchStatusEnum = BatchStatusEnum;

  public readonly queryParams$: Observable<Params> = this._route.queryParams;
  public searchControl: FormControl = this._fb.control(
    this.queryParamMap.get('search')
  );
  constructor(
    private readonly _fb: FormBuilder,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute
  ) {}

  public get queryParamMap() {
    return this._route.snapshot.queryParamMap;
  }

  public ngOnDestroy(): void {}

  public ngOnInit() {
    this.listenToSearch();
  }

  public listenToSearch(): void {
    this.searchControl.valueChanges
      .pipe(debounceTime(350), untilDestroyed(this))
      .subscribe((res) => {
        this.searchChange.next(res || null);
      });
  }

  public duplicate(type: DuplicateType): void {
    this.duplicateChange.next(type);
  }

  public remove(): void {
    this.removeChange.next(true);
  }

  public typeFilter(status: BatchStatus) {
    const queryType = this._route.snapshot.queryParamMap.get('status');
    return this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { status: queryType === status ? null : status, page: 1 },
      queryParamsHandling: 'merge',
    });
  }
}
